/** @jsx jsx */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { jsx, css } from '@emotion/core'
import { map, get, size, filter, keys, replace } from 'lodash'
import { adminClientList } from '../actions/admin_client'
import InputField from '../../components/form/InputField'
import DefaultButton from '../../components/DefaultButton'
import { FormikDropdownField } from '../../components/Dropdown'
import Timestamp from '../../components/Timestamp'
import AdminCreationFooter from './AdminCreationFooter'
import { FormikInputField } from '../../components/form/InputField'
import { FormikTextarea } from '../../components/form/TextareaField'
import { default_theme as theme } from '../../emotion/theme'
import { Formik, Form, FieldArray, Field } from 'formik'
import { Col, Row, Container, Button } from 'react-bootstrap'
import Card from '../../components/layout/Card'
import { FormLabelValue } from '../../components/form/FormLabelValue'
import { FormFieldWithAction } from '../../components/form/FormFieldWithAction'
import { FormikFileUploadField } from '../../components/form/FileUploader'
import * as Yup from 'yup'

const validationSchema = Yup.object().shape({
    'name': Yup.string().required("Name is required")
})

class AdminClientForm extends Component {
    
    componentDidMount() {
        const { dispatch, client_id } = this.props
        dispatch(adminClientList.ensureObjectLoaded(client_id))
    }

    onSave = (values, setSubmitting, setFieldError) => {
        const { onSubmit } = this.props
        onSubmit(values).then( (res) => {
            setSubmitting(false)
            if ( res.errors ) {
                map(keys(res.errors), (field_name) => setFieldError(field_name, res.errors[field_name]))
            }
        })
    }

    render() {
        const { onCancel,
                error,
                client,
                initialValues
              } = this.props

        const client_url = replace(get(window, ['LOCAL_SETTINGS', 'CLIENT_TOKENISED_URL'], 'dev internal error: not configured'), "CLIENT_SLUG", client.url_slug)
 
        return (
            <Formik
                initialValues={initialValues}
                onSubmit={(values, { setSubmitting, setFieldError }) => {this.onSave(values, setSubmitting, setFieldError)}}
                enableReinitialize={true}
                validationSchema={validationSchema}
            >
              {formik_props => {
                   const { values } = formik_props
                   return (
                       <Form>
                         <Row>
                           <Col>
                             <Card title="Client Details">
                               <Row>
                                 <Col>
                                   <FormLabelValue>
                                     Name
                                     <FormikInputField
                                         name="name"
                                         type="text"
                                         placeholder="Enter a client name here"
                                     />
                                   </FormLabelValue>
                                   
                                 </Col>
                               </Row>
                               <Row>
                                 <Col>
                                   <FormLabelValue>
                                     Primary colour (eg, for bright blue use: #0000ff)
                                     <FormikInputField
                                         name="primary_colour"
                                         type="text"
                                         placeholder="Primary colour"
                                     />
                                   </FormLabelValue>
                                   
                                 </Col>
                               </Row>

                               <Row>
                                 <Col>
                                   <FormLabelValue>
                                     Url subdomain
                                     <FormikInputField
                                         name="url_slug"
                                         type="text"
                                         placeholder="Url subdomain"
                                     />
                                   </FormLabelValue>
                                 </Col>
                                 <Col>
                                   url is: <a href={client_url} target="_blank">{client_url}</a>
                                 </Col>
                               </Row>

                               <Row>
                                 <Col>
                                   <FormLabelValue>
                                     Logo (320px x 70px)
                                     <FormikFileUploadField name="logo"
                                                            upload_relative_url='file_info/'
                                                            file_types=".jpg, .png, .jpeg"
                                                            formik_props={formik_props}
                                     />
                                   </FormLabelValue>
                                 </Col>
                               </Row>
                               
                               <Row>
                                 <Col>
                                   <FormLabelValue>
                                     Login image
                                     <FormikFileUploadField name="login_image"
                                                            upload_relative_url='file_info/'
                                                            file_types=".jpg, .png, .jpeg"
                                                            formik_props={formik_props}
                                     />
                                   </FormLabelValue>
                                 </Col>
                               </Row>
                               
                             </Card>
                           </Col>
                         </Row>
                         
                         <Row>
                           <Col>
                             <Button type="submit">
                               Save
                             </Button>
                           </Col>
                         </Row>
                       </Form>
                   )}
              }
            </Formik>
        )
    } 
}

function mapStateToProps(state, props) {
    const { onSubmit, client_id, onCancel } = props
    let client = adminClientList.getObject(client_id) || {}
    return {
        onSubmit,
        onCancel,
        client,
        initialValues: client
    }
}
export default withRouter(connect(mapStateToProps)(AdminClientForm))

const form_layout = css`
width: 100%;
display: flex;
flex-direction: column;
align-items: flex-start;
justify-content: flex-start;
margin: 10px;
padding: 10px;
@media(max-width: 1300px) {
align-items: center;
}
`

const row_container = css`
width: 50%;
display: flex;
flex-direction: row;
align-items: flex-start;
justify-content: flex-start;
@media(max-width: 1300px) {
    width: 700px;
}
`

const column_container = css`
display: flex;
flex-direction: column;
flex-wrap: wrap;
justify-content: flex-start;
width: 100%;
@media(max-width: 1300px) {
    flex-wrap: nowrap;
    height: auto;
}
`

const field_container = css`
width: 100%;
display: flex;
flex-direction: column;
padding-left: 30px;
padding-right: 30px;
`

const error_container = css`
display: flex;
align-items: center;
min-height: 30px;
flex-direction: column;
padding-top: 20px;

p {
margin: 0;
padding: 0;
color: ${theme.colors.error};
}
`

const footer = css`
display: flex;
flex-direction: column;
width: 100%;
`

const footer_row = css`
display: flex;
flex-direction: row;
text-align: center;
justify-content: space-between;
width: 100%;
padding-top:50px;
`

const label = css`
color: ${theme.colors.secondary};
font-weight: 600;
`

const row = css`
display: flex; 
justify-content: space-between;
`

const cell = css`
width: 45%;
`

const label_center = css`
color: ${theme.colors.secondary};
font-weight: 600;
text-align: center;
width: 100%;
`

const multi_value_row = css`
display: flex;
justify-content: space-between;
margin: 10px;
padding: 10px;
box-shadow: 0 0 1.5px 0 rgba(0, 0, 0, 0.12), 0 1.5px 1.5px 0 rgba(0, 0, 0, 0.24);
`

const button_group = css`
width: 100%;
display: flex;
justify-content: end;
`

const multi_value_section = css`
margin-top: 20px;
`

const row_separator = css`
margin-top: 20px;
`

